export default __webpack_public_path__ + "static/media/es-bg.61444ff2.webp";